var _defs, _ellipse, _g, _path, _path2, _circle, _path3, _path4, _circle2, _path5, _path6, _circle3, _path7, _path8, _circle4, _g2, _path9, _path0, _path1, _polygon, _path10, _polygon2, _polygon3, _polygon4, _path11, _polygon5, _path12, _path13, _path14, _polygon6, _polygon7, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneratingApiKeyDashboardIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 784.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#151616;}.cls-2,.cls-6{opacity:0.1;}.cls-3{clipPath:url(#clipPath);}.cls-4{fill:#e8e8e8;}.cls-11,.cls-5,.cls-7{fill:#fff;}.cls-11,.cls-5{opacity:0.6;}.cls-16,.cls-5,.cls-6,.cls-8{isolation:isolate;}.cls-13,.cls-8{opacity:0.15;}.cls-12,.cls-9{fill:#007cff;}.cls-9{opacity:0.7;}.cls-10{opacity:0.43;}.cls-14{opacity:0.3;}.cls-15{fill:#ffb570;}.cls-16{opacity:0.2;}.cls-17{fill:#b97964;}.cls-18{fill:#272a2b;}.cls-19{fill:#484c5e;}.cls-20{fill:#263238;}.cls-21{fill:#aab7c1;}.cls-22{fill:#e4897b;}.cls-23{fill:#dee6f1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath",
    transform: "translate(0 -123.12)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 360.36,
    y: 172.15,
    width: 371.18,
    height: 690.96,
    rx: 44.7
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-2",
    cx: 540,
    cy: 759.14,
    rx: 540,
    ry: 25.59
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M731.55,133.26V875.15a21.27,21.27,0,0,1-21.27,21.27H370.34a9.76,9.76,0,0,1-7-2.82,10,10,0,0,1-3-7.26V142.62a19.55,19.55,0,0,1,19.5-19.5h88.46a7,7,0,0,1,6.4,4.47l4.13,10.13a7,7,0,0,0,6.4,4.44H606.9a6.91,6.91,0,0,0,6.39-4.36l4.13-10.19a7,7,0,0,1,6.4-4.49h98A10,10,0,0,1,731.55,133.26Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 681.09,
    y: 20.89,
    width: 3.07,
    height: 6.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 686.26,
    y: 141.49,
    width: 24.43,
    height: 11.93,
    transform: "translate(1396.96 171.79) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M527.35,142.15,420.5,542.41v0l-1.19,4.49v0l-1.93,7.21v0l-1.21,4.5-55.8,209v-253L464.92,123.12h3.4a7,7,0,0,1,6.4,4.47l4.12,10.14a7,7,0,0,0,6.4,4.42Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "731.55 223.45 731.55 476.4 664.91 726.04 663.29 732.11 652.29 773.3 584.77 773.3 595.76 732.13 597.52 725.52 606.35 692.45 608.11 685.83 611.65 672.6 613.42 665.99 616.94 652.76 618.7 646.14 674.26 438.07 674.26 438.04 676.83 428.43 676.83 428.41 731.55 223.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M564,142.15,457.76,539.91l-.65,2.38-5.8,21.8-.64,2.38L363.34,893.61a10.09,10.09,0,0,1-3-7.28V847.85l75.12-281.38.64-2.38,5.8-21.8.65-2.38L548.77,142.15Z",
    transform: "translate(0 -123.12)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M646,497.17h0a11.32,11.32,0,0,0,11.32-11.32V307A11.32,11.32,0,0,0,646,295.7h0A11.33,11.33,0,0,0,634.65,307V485.85A11.32,11.32,0,0,0,646,497.17Z",
    transform: "translate(0 -123.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M646,492.73a6.89,6.89,0,0,1-6.89-6.88V307a6.89,6.89,0,0,1,13.77,0V485.85A6.89,6.89,0,0,1,646,492.73Z",
    transform: "translate(0 -123.12)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 645.98,
    cy: 324.65,
    r: 16.42,
    transform: "translate(222.05 787.16) rotate(-80.78)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M579.29,497.17h0a11.32,11.32,0,0,0,11.33-11.32V307a11.33,11.33,0,0,0-11.33-11.33h0A11.32,11.32,0,0,0,568,307V485.85A11.32,11.32,0,0,0,579.29,497.17Z",
    transform: "translate(0 -123.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M579.29,492.73a6.89,6.89,0,0,1-6.88-6.88V307a6.89,6.89,0,0,1,13.77,0V485.85A6.89,6.89,0,0,1,579.29,492.73Z",
    transform: "translate(0 -123.12)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 579.29,
    cy: 458.01,
    r: 16.42,
    transform: "translate(34.41 833.34) rotate(-80.78)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M512.61,497.17h0a11.32,11.32,0,0,0,11.33-11.32V307a11.33,11.33,0,0,0-11.33-11.33h0A11.32,11.32,0,0,0,501.29,307V485.85A11.32,11.32,0,0,0,512.61,497.17Z",
    transform: "translate(0 -123.12)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M512.61,492.73a6.89,6.89,0,0,1-6.88-6.88V307a6.88,6.88,0,1,1,13.76,0V485.85A6.89,6.89,0,0,1,512.61,492.73Z",
    transform: "translate(0 -123.12)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 512.61,
    cy: 369.1,
    r: 16.42,
    transform: "translate(66.17 692.85) rotate(-80.78)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M445.93,497.17h0a11.32,11.32,0,0,0,11.33-11.32V307a11.33,11.33,0,0,0-11.33-11.33h0A11.33,11.33,0,0,0,434.6,307V485.85A11.33,11.33,0,0,0,445.93,497.17Z",
    transform: "translate(0 -123.12)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M445.93,492.73a6.89,6.89,0,0,1-6.88-6.88V307a6.88,6.88,0,0,1,13.76,0V485.85A6.89,6.89,0,0,1,445.93,492.73Z",
    transform: "translate(0 -123.12)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 445.93,
    cy: 435.78,
    r: 16.42,
    transform: "translate(-55.65 683.03) rotate(-80.78)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 645.98,
    cy: 324.65,
    r: 16.42,
    transform: "translate(222.05 787.16) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M646,336.62a12,12,0,1,1,12-12A12,12,0,0,1,646,336.62Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 579.29,
    cy: 458.01,
    r: 16.42,
    transform: "translate(34.41 833.34) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M579.29,470a12,12,0,1,1,12-12A12,12,0,0,1,579.29,470Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 512.61,
    cy: 369.1,
    r: 16.42,
    transform: "translate(66.17 692.85) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M512.61,381.08a12,12,0,1,1,12-12A12,12,0,0,1,512.61,381.08Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 445.93,
    cy: 435.78,
    r: 16.42,
    transform: "translate(-55.65 683.03) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M445.93,447.76a12,12,0,1,1,12-12A12,12,0,0,1,445.93,447.76Z",
    transform: "translate(0 -123.12)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M515.7,725.49v27l13.9,1.31A72.26,72.26,0,0,0,540,778.74L531,789.53l19.09,19.09,10.79-8.93a72.06,72.06,0,0,0,24.94,10.37l1.31,13.9h27l1.31-13.9a72.15,72.15,0,0,0,24.94-10.37l10.78,8.93,19.09-19.09-8.92-10.79a72,72,0,0,0,10.36-24.94l13.91-1.31v-27l-13.91-1.3a72,72,0,0,0-10.36-24.94l8.92-10.79L651.2,669.37l-10.78,8.93a72.15,72.15,0,0,0-24.94-10.37L614.17,654h-27l-1.31,13.9a72.06,72.06,0,0,0-24.94,10.37l-10.79-8.93L531,688.46,540,699.25a72.26,72.26,0,0,0-10.37,24.94Zm85-23A36.56,36.56,0,1,1,564.12,739,36.56,36.56,0,0,1,600.67,702.44Z",
    transform: "translate(0 -123.12)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M406.27,648v21.16l10.9,1a56.59,56.59,0,0,0,8.12,19.54l-7,8.45,15,15,8.46-7a56.34,56.34,0,0,0,19.54,8.13l1,10.89h21.16l1-10.89A56.42,56.42,0,0,0,504,706.1l8.45,7,15-15-7-8.45a56.59,56.59,0,0,0,8.12-19.54l10.89-1V648l-10.89-1a56.56,56.56,0,0,0-8.12-19.55l7-8.45-15-15L504,611a56.8,56.8,0,0,0-19.54-8.13l-1-10.89H462.27l-1,10.89A56.72,56.72,0,0,0,441.71,611l-8.46-7-15,15,7,8.45a56.56,56.56,0,0,0-8.12,19.55Zm66.58-18.06a28.64,28.64,0,1,1-28.64,28.64A28.64,28.64,0,0,1,472.85,629.9Z",
    transform: "translate(0 -123.12)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M524.27,582.64v17.77l9.15.87a47.58,47.58,0,0,0,6.83,16.41l-5.88,7.1,12.56,12.57,7.1-5.88a47.34,47.34,0,0,0,16.42,6.82l.86,9.15h17.77l.86-9.15a47.34,47.34,0,0,0,16.42-6.82l7.1,5.88L626,624.79l-5.88-7.1A47.58,47.58,0,0,0,627,601.28l9.15-.87V582.64l-9.15-.86a47.5,47.5,0,0,0-6.83-16.41l5.88-7.1L613.46,545.7l-7.1,5.88a47.55,47.55,0,0,0-16.42-6.83l-.86-9.14H571.31l-.86,9.14A47.55,47.55,0,0,0,554,551.58l-7.1-5.88-12.56,12.57,5.88,7.1a47.5,47.5,0,0,0-6.83,16.41Zm55.92-15.17a24.06,24.06,0,1,1-24.05,24.06A24.06,24.06,0,0,1,580.19,567.47Z",
    transform: "translate(0 -123.12)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "493.23 529.96 478.31 515.05 457.94 520.51 452.48 540.88 467.39 555.8 487.77 550.34 493.23 529.96"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M406.27,648v21.16l10.9,1a56.59,56.59,0,0,0,8.12,19.54l-7,8.45,15,15,8.46-7a56.34,56.34,0,0,0,19.54,8.13l1,10.89h21.16l1-10.89A56.42,56.42,0,0,0,504,706.1l8.45,7,15-15-7-8.45a56.59,56.59,0,0,0,8.12-19.54l10.89-1V648l-10.89-1a56.56,56.56,0,0,0-8.12-19.55l7-8.45-15-15L504,611a56.8,56.8,0,0,0-19.54-8.13l-1-10.89H462.27l-1,10.89A56.72,56.72,0,0,0,441.71,611l-8.46-7-15,15,7,8.45a56.56,56.56,0,0,0-8.12,19.55Zm66.58-18.06a28.64,28.64,0,1,1-28.64,28.64A28.64,28.64,0,0,1,472.85,629.9Z",
    transform: "translate(0 -123.12)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "493.23 529.96 478.31 515.05 457.94 520.51 452.48 540.88 467.39 555.8 487.77 550.34 493.23 529.96"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "603.96 589.95 579.86 600.06 576.57 625.99 597.37 641.81 621.48 631.7 624.77 605.76 603.96 589.95"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "595.18 477.06 595.18 459.76 580.2 451.11 565.21 459.76 565.21 477.06 580.2 485.71 595.18 477.06"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M524.27,582.64v17.77l9.15.87a47.58,47.58,0,0,0,6.83,16.41l-5.88,7.1,12.56,12.57,7.1-5.88a47.34,47.34,0,0,0,16.42,6.82l.86,9.15h17.77l.86-9.15a47.34,47.34,0,0,0,16.42-6.82l7.1,5.88L626,624.79l-5.88-7.1A47.58,47.58,0,0,0,627,601.28l9.15-.87V582.64l-9.15-.86a47.5,47.5,0,0,0-6.83-16.41l5.88-7.1L613.46,545.7l-7.1,5.88a47.55,47.55,0,0,0-16.42-6.83l-.86-9.14H571.31l-.86,9.14A47.55,47.55,0,0,0,554,551.58l-7.1-5.88-12.56,12.57,5.88,7.1a47.5,47.5,0,0,0-6.83,16.41Zm55.92-15.17a24.06,24.06,0,1,1-24.05,24.06A24.06,24.06,0,0,1,580.19,567.47Z",
    transform: "translate(0 -123.12)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "595.18 477.06 595.18 459.76 580.2 451.11 565.21 459.76 565.21 477.06 580.2 485.71 595.18 477.06"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M937,435.77l27,21.93s6.6.13,8.67,2.31,10,18.38,8.91,20.59-14.45,6.58-17.26,4-7.68-17.6-7.59-19.2l-34.49-23.13Z",
    transform: "translate(0 -123.12)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952,445.41l-6,13.17s-37.11-17.38-45.16-27.5c-2-2.62-4.89-6.78-8-11.52-5-7.84-10.76-17.28-14.72-23.9-2.94-5-4.92-8.32-4.92-8.32l21-33.14c4.59,3.53,18.64,60.16,21.15,63.2S952,445.41,952,445.41Z",
    transform: "translate(0 -123.12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M892.8,419.56c-5-7.84-10.76-17.28-14.72-23.9l9.77-24.1S893.15,399.21,892.8,419.56Z",
    transform: "translate(0 -123.12)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "946.28 754.56 930.35 757.38 923.82 735.66 917.86 715.73 936.22 709.32 941.55 733.27 946.28 754.56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "839.95 754.97 823.78 754.97 821.12 733.27 818.72 713.01 837.92 710.1 839 733.89 839.95 754.97"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M929.73,875l16.63-5.71c.77,0,2.86,6.25,3,7l3.71,16.74a2.76,2.76,0,0,1-2.14,3.28,2.11,2.11,0,0,1-.61.06c-7.39-.11-8-.57-17.26-.57-5.71,0-23,.6-30.84.6s-8.92-7.8-5.69-8.51c14.48-3.16,25.39-7.53,30-11.7A4.58,4.58,0,0,1,929.73,875Z",
    transform: "translate(0 -123.12)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M822.07,875h18a1.65,1.65,0,0,1,1.6,1.29l3.71,16.74a2.77,2.77,0,0,1-2.14,3.28,2.11,2.11,0,0,1-.61.06c-7.39-.11-8-.57-17.26-.57-5.72,0-23,.6-30.85.6s-8.91-7.8-5.69-8.51c14.49-3.16,25.4-7.53,30-11.7A4.59,4.59,0,0,1,822.07,875Z",
    transform: "translate(0 -123.12)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M947.76,872.84l-25,3.61a3.81,3.81,0,0,1-4.09-2.36c-25.91-65.49-47.14-151.42-60.22-196.38-7.15-24.6-12.82-46.48-17.1-65.9l1.11,71.66,2.79,189.19a3.76,3.76,0,0,1-3.76,3.82H814.86a3.79,3.79,0,0,1-3.69-3c-63.71-304.66-13.93-406.73-13.93-406.73l77.38-12.93c2.94,11.55,5.16,30.41,6.48,43.44l3.49,25.66,30.24,156.21L951,868.35A3.81,3.81,0,0,1,947.76,872.84Z",
    transform: "translate(0 -123.12)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M862,689.76c-1.22-4.09-2.52-8.11-3.67-12-6.48-22.33-10.81-42.42-15.88-60.44v0L839.84,584s16.55-36.46,10.36-62.12c.57,1.46,11.53,29.41,7.22,57.34A812.72,812.72,0,0,0,862,689.76Z",
    transform: "translate(0 -123.12)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M864.26,320.89a3.66,3.66,0,0,1-.67.37,28.36,28.36,0,0,1-10.54,3.56c-10.8,1.06-17.77-1.31-21.82-6.66h0c-5.62-8-5.61-20.78-2.71-35.86,1.31-6.92,3.1-12.85,5.63-17.32,0-.05,0-.22.08-.27s.23-.43.35-.61c3.72-6.21,9.05-9.86,16.89-10.67a41.5,41.5,0,0,1,9.12.16C890.24,257.14,889.18,306.92,864.26,320.89Z",
    transform: "translate(0 -123.12)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M863.59,321.26a27.8,27.8,0,0,1-10.49,3.15c-10.79,1-17.72-1.66-21.77-7.08,5,1.81,11.87,3.14,19,.91C854.83,316.84,859.42,318.45,863.59,321.26Z",
    transform: "translate(0 -123.12)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M865.81,345.53c2.66,8.29-8,12.82-8,12.82-18.69-5.9-23-15.12-23-15.12,14.2-9.27,7.7-30.93,7.7-30.93l3.2,1.2,21.78,2.08s-4.81,12-5.34,14.64c0,0,0,0,0,.07C859.51,344.25,865.81,345.53,865.81,345.53Z",
    transform: "translate(0 -123.12)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M834.13,264.78s-4.33,20.57,14.2,32.06c0,0,5.65,22.69,18.06,24.62,16.92,2.62,35-19.58,32.34-44.95C895.26,243.62,847.27,234.73,834.13,264.78Z",
    transform: "translate(0 -123.12)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M839.13,289.58c.43-3.24,3.75-8.35,8.69-7,5.12,1.45,6.33,14.68-6.86,15.89C839.07,298.68,838.24,296.34,839.13,289.58Z",
    transform: "translate(0 -123.12)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M797.24,467s-14.76-89.94,10.61-130.26c0,0,50.67-3.15,86.31,17.43,0,0-14.73,40-16.92,112.83Z",
    transform: "translate(0 -123.12)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M792.62,398.21c-1.09-12.2,2.44-23.95,3-34.3,9.31-7.76,16.68-19,16.68-19S817,381.33,792.62,398.21Z",
    transform: "translate(0 -123.12)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M705.77,337.6l-30.22-17.51s-3.89-5.33-6.87-5.78-20.81,2.31-22,4.51,2.89,15.61,6.64,16.41,18.83-3.79,20.09-4.79l30.63,17.2Z",
    transform: "translate(0 -123.12)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M812.18,339.27a4.4,4.4,0,0,0-4.89-2.45c-11,2.25-47.61,9.58-54.53,9.06-5.11-.38-61.1-19.31-61.1-19.31l-4.13,15s58.82,24.71,66,26c16.8,3.06,52.39,3.41,52.39,3.41S818.78,353.7,812.18,339.27Z",
    transform: "translate(0 -123.12)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M887.85,260.29s17.22-14.65,34.32-5.43-2.81,44.7,2.18,55.58,15.84,10.07,2.17,17.23-.44,13.09-.44,13.09-12.24,4.15-13.24-5.93-5.42-18.41-9.38-20.14,6.71-20.85,3-30.32S892,275.72,892,275.72Z",
    transform: "translate(0 -123.12)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M860.56,253.59s-21.73-13.62-31.95-3.94c-15.79,14.94,6.71,36.4,30.54,46.57Z",
    transform: "translate(0 -123.12)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M400,528.58,222,330.43a43.35,43.35,0,0,0-47.35-60.71,3,3,0,0,0-1.76,5l23.34,26a3.84,3.84,0,0,1,.79,3.74L192,320a3.79,3.79,0,0,1-2.84,2.55l-15.94,3.37a3.8,3.8,0,0,1-3.63-1.18l-23.35-26a3,3,0,0,0-5.19,1.21,43.34,43.34,0,0,0,55.29,53.57l178,198.14a43.34,43.34,0,0,0,47.36,60.71,3,3,0,0,0,1.76-5l-23.34-26a3.77,3.77,0,0,1-.79-3.73l5.05-15.5a3.84,3.84,0,0,1,2.84-2.55l15.95-3.37a3.82,3.82,0,0,1,3.63,1.19l23.34,26a3,3,0,0,0,5.19-1.22A43.33,43.33,0,0,0,400,528.58Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M400,528.58,222,330.43a43.35,43.35,0,0,0-47.35-60.71,3,3,0,0,0-1.76,5l23.34,26a3.84,3.84,0,0,1,.79,3.74L192,320a3.79,3.79,0,0,1-2.84,2.55l-15.94,3.37a3.8,3.8,0,0,1-3.63-1.18l-23.35-26a3,3,0,0,0-5.19,1.21,43.34,43.34,0,0,0,55.29,53.57l178,198.14a43.34,43.34,0,0,0,47.36,60.71,3,3,0,0,0,1.76-5l-23.34-26a3.77,3.77,0,0,1-.79-3.73l5.05-15.5a3.84,3.84,0,0,1,2.84-2.55l15.95-3.37a3.82,3.82,0,0,1,3.63,1.19l23.34,26a3,3,0,0,0,5.19-1.22A43.33,43.33,0,0,0,400,528.58Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M199,295.08s-52.83,6.93-59.68,16.35-7.24,18.17,24,27.13l9.14-6.65s-12.95-5-11.43-8S199,322,199,322Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218.8,294.4l-7.36,25.68L199.09,322l-25.88,3.93-.76-10.35L171,295.09S196.37,290,218.8,294.4Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M205.76,305.26,199.09,322l-25.88,3.93-.76-10.35C185.59,305.31,205.76,305.26,205.76,305.26Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "200.67 754.41 221.25 756.56 222.29 744.64 225.1 712.19 204.53 710.01 201.41 745.86 200.67 754.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "97.97 751.79 117.91 751.79 118.09 747.28 118.12 746.72 119.13 717.8 119.16 717.22 119.56 706.13 99.6 706.13 97.97 751.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M120.68,873.71H96.45a1.75,1.75,0,0,0-1.7,1.37l-3.93,17.76a2.94,2.94,0,0,0,2.27,3.49,2.78,2.78,0,0,0,.64.06c7.84-.12,13.55-.61,23.4-.61,6.06,0,24.35.64,32.72.64s9.47-8.27,6-9C140.52,884,129,879.39,124,875A4.82,4.82,0,0,0,120.68,873.71Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M223.43,873.08H199.2a1.74,1.74,0,0,0-1.7,1.37l-3.93,17.76a2.94,2.94,0,0,0,2.27,3.49,3.49,3.49,0,0,0,.65.06c7.84-.13,13.54-.61,23.39-.61,6.06,0,24.35.63,32.73.63s9.46-8.27,6-9c-15.37-3.35-26.94-8-31.86-12.4A4.77,4.77,0,0,0,223.43,873.08Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M227.68,874.75H197.47a4.07,4.07,0,0,1-4.08-4c-.67-33.27-6.34-265.07-35.68-343.93,3.55,144.5-24.88,315.15-29.82,343.52a4.93,4.93,0,0,1-4.87,4.09H96.69a5,5,0,0,1-4.92-5.5c3.14-27.57,16.86-151.52,16.86-206.82,0-110.64-30.35-164.68-.8-236.26H213.67c25.74,155.07,40,274.71,18.07,445.32A4.12,4.12,0,0,1,227.68,874.75Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M304.85,303.69c-.78.63-1.57,1.22-2.37,1.75a27.66,27.66,0,0,1-15.76,4.69,27.13,27.13,0,0,1-4.23-.36,25.1,25.1,0,0,1-17.93-12.09,25.56,25.56,0,0,1-3.23-9.5c-2-14.06,5.13-23.26,16-39.78a27,27,0,0,1,46.05.55C334.2,266.81,318.86,292,304.85,303.69Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M286.72,310.13a27.13,27.13,0,0,1-4.23-.36,25.1,25.1,0,0,1-17.93-12.09,29.16,29.16,0,0,1,6.82-3.28S281.93,300,286.72,310.13Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M239.59,307.05c2.55,12.88,23.62,24.43,23.62,24.43s14.36,5.58,14.62,0c-6.17-6.37-7.14-12.18-5.44-17.42a25.59,25.59,0,0,1,5.24-8.56,55.13,55.13,0,0,1,3.91-4l-10.67-35C265.41,280.27,253.45,304.34,239.59,307.05Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M332.15,251.36c-2.15-12-8.24-12.59-8.24-12.59-.59-9.59-23.22-19.29-38-16.18S261,238.8,256.94,250.83c-5.9,17.51-2.34,39.26-2.34,39.26h0c12,9.12,24.47,10.81,28.26,4S296,285.06,296,285.06c5.7,5,14.74,0,14.74,0s10.23-3.53,12-13.53S334,261.51,332.15,251.36Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M295.56,279.37c-1.61,4.15-1.59,8.09.06,10.95,2.21,3.76,7.7.78,10.77-4.33,2.68-4.55,4.9-12.11.87-13.89S297.6,274.27,295.56,279.37Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M298.17,222.49c22.25-6.64,40.16,29.88,39.28,49.24-.72,15.73-17.24,13.82-17.24,13.82s9.12-.6,8.24-11.65c0,0-3.95,13.52-12.8,4.65s1.63-30,1.63-30Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M155.27,630.21a723.09,723.09,0,0,0-11.19-73c-30-37.65-13.6-72.4-13.6-72.4,4,24.17,27.23,42,27.23,42C158.54,560.85,157.48,596,155.27,630.21Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M239.54,301.26s6.44-4.76,18.32,2.26S273.65,324,273.65,324Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M225.1,475.78s0-61.73,64.54-136.44c0,0-29-40.46-70.84-44.94,0,0-77.28,26.53-119.38,139.52Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.63,339.34q-10.23,11.87-18.39,23.24a290.85,290.85,0,0,0-25.37,42c-20.75,42.27-20.75,71.22-20.75,71.22L99.43,433.92C141.52,320.92,218.8,294.4,218.8,294.4,260.66,298.89,289.63,339.34,289.63,339.34Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M271.24,362.58a290.85,290.85,0,0,0-25.37,42c-.81-32.52,23.44-50.26,23.44-50.26Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M289.64,358.42v78.21l30.28,54.47L332.38,505s-14.55,9-18.57,3.21-8-17.09-8-17.09S275.7,450.7,271,441s-6.43-68-6.43-68Z",
    transform: "translate(0 -123.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M289.64,339.34c4.77,13.19,4.73,58.16,4.73,58.16l-33.8,2.95-2.71-17.76a62.12,62.12,0,0,1,11.62-32C277.22,339.88,289.64,339.34,289.64,339.34Z",
    transform: "translate(0 -123.12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratingApiKeyDashboardIllustration);
export default __webpack_public_path__ + "static/media/Generating_API_key_dashboard_illustration.70c27e9dea86e1d9f2af03036c9f3c90.svg";
export { ForwardRef as ReactComponent };